import { render, staticRenderFns } from "./WhereWeDeliverTheCard.vue?vue&type=template&id=5b951e4d&"
import script from "./WhereWeDeliverTheCard.vue?vue&type=script&lang=js&"
export * from "./WhereWeDeliverTheCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports